import { c as _c } from "react/compiler-runtime";
import { checkBulletIcon } from '@/uiIcons/checkBulletIcon.css';
import { minusIcon } from '@/uiIcons/minusIcon.css';
import { plusIcon } from '@/uiIcons/plusIcon.css';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';
import { occupy } from '@/uiPrimitives/layout/occupy';
import { icon } from '@/uiPrimitives/media/icon';
import { textBlock } from '@/uiPrimitives/typography/text';
import { olMarker, ulChildMarker, ulMarker } from './listItem.css';
import { translateInline } from '@/globals/translate/translateInline';
export const ULMarker = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <i aria-hidden={true} className={ulMarker} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const ULChildMarker = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <i aria-hidden={true} className={ulChildMarker} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const OLMarker = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={classes(box({
      backgroundColor: "positiveBlue",
      borderRadius: "circle",
      aspectRatio: "1 / 1",
      blockSize: "2 | h2"
    }), occupy({}))}><div className={textBlock({
        capSize: "-2 | smaller",
        fontVariantNumeric: "lining-nums",
        textAlign: "center",
        fontWeight: "bold"
      })}><i aria-hidden={true} className={olMarker} /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const ChecklistMarker = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <i role="img" aria-label={translateInline({
      en: "Checkmark",
      nl: "Vinkje"
    })} className={icon({
      icon: checkBulletIcon,
      fill: "positiveBlue",
      blockSize: "1 | h3"
    })} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const ProsListMarker = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <i role="img" aria-label={translateInline({
      en: "Pro",
      nl: "Voordeel"
    })} className={icon({
      icon: plusIcon,
      fill: "positiveGreen",
      blockSize: "1 | h3"
    })} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const ConsListMarker = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <i role="img" aria-label={translateInline({
      en: "Con",
      nl: "Nadeel"
    })} className={icon({
      icon: minusIcon,
      fill: "positiveRed",
      blockSize: "1 | h3"
    })} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};